import _ from 'lodash'
import React from 'react'
import { useTheme } from 'react-jss'
import { Helmet } from 'react-helmet'
import Alert from '../alert'
import Button from '../button'
import FooterCheckout from '../footer-checkout'
import HeaderCheckout from '../header-checkout'
import useStyles from './layout-checkout-style'
import Modal from '../modal'
import PaymentLogos from '../payment-logos'
import { useModal } from '../../hook/use-modal'

const LayoutCheckoutView = ({
  children,
  disableFooter,
  disablePaymentFooter,
  disableHeaderLogoLink,
  headerLogo,
}) => {
  const modal = useModal()
  const styles = useStyles()
  const theme = useTheme()
  const extraScripts = _.get(theme, 'config.pages.layout.extraScripts', [{}])
  return (
    <div className={styles.containerFluid}>
      {!_.isEmpty(_.get(theme, 'typo.fontFamilyUrl')) && (
        <Helmet>
          <link href={_.get(theme, 'typo.fontFamilyUrl')} rel="stylesheet" />
        </Helmet>
      )}
      <HeaderCheckout
        className={styles.header}
        disableLogoLink={disableHeaderLogoLink}
        logo={headerLogo}
      />
      <div className={styles.container}>{children}</div>
      { !disablePaymentFooter && <PaymentLogos /> }
      { !disableFooter && <FooterCheckout useSuspense={false} /> }
      {!_.isEmpty(extraScripts)
        && _.map(extraScripts, (script, idx) => <script key={idx} type={script.type}>{`${script.code}`}</script>)}
      <Alert />
      <Modal
        dialog
        className={styles.dialogModal}
        overlayClassName={styles.dialogModalOverlay}
        titleClassName={styles.dialogTitle}
        isOpen={modal.isOpen}
        title={modal.title}
      >
        <div className={styles.dialogContainer}>
          <div className={styles.dialogBody}>
            {
              !_.isEmpty(modal.message) && (
                <p className={styles.dialogDescription}>{modal.message}</p>
              )
            }
            {modal.contentComponent}
          </div>
          <div className={styles.dialogButtons}>
            {
              _.map(modal.buttons, (button, index) => (
                <Button
                  key={`modal_button_${index}`}
                  className={styles.button}
                  dark={index === 0}
                  border={index !== 0}
                  {...button}
                />
              ))
            }
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default LayoutCheckoutView
